import {css} from 'lit';
export const styles = css`:host{display:block}.tags-container{margin-top:.5rem;display:flex;gap:.5rem;flex-wrap:wrap}@media screen and (min-width: 992px){.tags-container{margin-top:.25rem}}`;
export default styles;
